import type { AppRouteRecordRaw } from '@/router/types';
import { useI18n } from '@/hooks/web/useI18n';
import { LAYOUT } from '@/router/constant';

const { t } = useI18n();

const BigScreenRoute: AppRouteRecordRaw = {
  path: '/local-monitoring-management',
  name: 'LocalDeviceMonitor',
  component: LAYOUT,
  meta: {
    title: t('router.localDeviceMonitoring'),
    icon: 'video-camera',
    hideBreadcrumb: true,
    hideMenu: false,
    layout: 'empty',
    orderNo: 10,
    perCode: 'kedex:escalator:monitoring'
  },
  children: [
    {
      path: 'site-overview',
      name: 'MonitoringOverviewIndex',
      component: () => import('@/views/localDeviceMonitor/monitorOverview.vue'),
      meta: {
        title: t('router.monitorOverview'),
        hideBreadcrumb: false,
        hideMenu: false,
        master: true,
        layout: 'empty',
        perCode: 'kedex:escalator:monitoring:overview'
      }
    },
    {
      path: 'history-report',
      name: 'HistoryReportIndex',
      component: () => import('@/views/localDeviceMonitor/historyReport.vue'),
      meta: {
        title: t('router.historyReport'),
        hideBreadcrumb: false,
        hideMenu: false,
        master: true,
        layout: 'empty',
        perCode: 'kedex:escalator:monitoring:history'
      }
    }
  ]
};

export default BigScreenRoute;
